module.exports = __webpack_public_path__ + "static/media/43-2.947c6fdc.mp3";